export const getCertificationUrl = () => process.env.REACT_APP_MP_CERTIFICATION_URL ?? 'http://localhost:3009'
export const getMarahFeedbackUrl = () => process.env.REACT_APP_MP_MARAH_FEEDBACK_URL ?? 'http://localhost:3014'
